import Axios from "axios";
import qs from "qs";
import router from "../router";
import { Message, Loading } from "element-ui";

let isfirst = true;

function valfirst() {
  if (isfirst) {
    isfirst = false;
    return true;
  } else {
    return false;
  }
}

let loading; //定义loading变量

function startLoading() {
  //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: "加载中……"
  });
}

function endLoading() {
  //使用Element loading-close 方法
  loading.close();
}
//那么 showFullScreenLoading() tryHideFullScreenLoading()将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0;
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    isfirst = true;
    endLoading();
  }
}

Axios.defaults.timeout = 10 * 60 * 1000;
// Axios.defaults.timeout = 3 * 1000;

Axios.defaults.baseURL = "";

//http request 拦截器
Axios.interceptors.request.use(
  config => {
    if (config.method === "post") {
      //支持2种方法，默认使用Form Data
      // console.log('=========',config.data.useRequestBody)
      if (config.data.useRequestBody) {
        //参数需要带上useRequestBody
        //如果useRequestBody=true, 支持Request Payload，
        //SpringMVC Controller 中需要使用@RequestBody
        delete config.data.useRequestBody;
        config.headers = {
          "Content-Type": "application/json;charset=UTF-8"
        };
      } else {
        //如果useRequestBody=false, 默认支持Form Data
        //SpringMVC Controller 中不需要使用@RequestBody，默认使用@RequestParam
        // config.data = qs.stringify(config.data);
        // config.headers = {
        //   'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        // }

        config.headers = {
          "Content-Type": "application/json;charset=UTF-8"
        };
      }
    } else if (config.method === "get") {
      let newParams = {};
      for (let key in config.params) {
        newParams[key] = encodeURIComponent(config.params[key]);
      }
      config.params = newParams;

      config.headers = {
        "Content-Type": "application/json;charset=UTF-8"
      };
    }
    // let token = sessionStorage.getItem('token')//这个是登录时存进本地环境的token
    let token = localStorage.getItem("token");
    if (token) {
      config.headers = {
        "x-api-key": token
      };
    }

    //显示等待框
    // console.log('拦截器--',config.url)

    let list = ["https://www.yulin365.net/api/v1/file/videos"];
    let isShowLoading = sessionStorage.getItem("is-loading");
    if (list.includes(config.url) && isShowLoading) {
      // if (needLoadingRequestCount === 0) {
      //   // startLoading();
      //   loading = Loading.service({
      //     lock: true,
      //     text: "上传中，请稍后……",
      //   });
      // }
      // needLoadingRequestCount++;
    } else {
      showFullScreenLoading();
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//http response 拦截器
Axios.interceptors.response.use(
  response => {
    // console.log('err=********', response);

    var data = response.data;
    // //隐藏等待框
    tryHideFullScreenLoading()
    if (response.data.code === 200) {
      //隐藏等待框
      tryHideFullScreenLoading();
      return Promise.resolve(response.data);
    } else {
      if (valfirst()) {
        // console.log('===========');
        switch (response.data.code) {
          // 401: 未登录
          // 未登录则跳转登录页面，并携带当前页面的路径
          // 在登录成功后返回当前页面，这一步需要在登录页操作。
          case 401:
            Message.error("未登录，请您登录");
            sessionStorage.removeItem("token");
            localStorage.removeItem("token");
            router.replace({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
            break;

          // 403 token过期
          // 登录过期对用户进行提示
          // 清除本地token和清空vuex中token对象
          // 跳转登录页面
          case 403:
            router.push({
              path: "/bindwechat"
            });
            Message.closeAll();
            Message.warning("请绑定微信号！");
            // // 清除token
            // sessionStorage.removeItem("token");
            // localStorage.removeItem("token");
            // store.commit("loginSuccess", null);
            // // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            // setTimeout(() => {
            //   router.replace({
            //     path: "/login",
            //     query: {
            //       redirect: router.currentRoute.fullPath,
            //     },
            //   });
            // }, 1000);
            break;

          // 404请求不存在
          case 404:
            Message.error("网络请求不存在");
            break;
          // 其他错误，直接抛出错误提示
          default:
            Message.error(response.data.message);
        }
      }
      //隐藏等待框
      tryHideFullScreenLoading();
      // console.log("=================edn", response.data);
      return Promise.reject(response.data);
      // return Promise.resolve(response.data)
    }
    // //隐藏等待框
    // tryHideFullScreenLoading()
    // return Promise.reject(response.data);
  },
  error => {
    // console.log("e********");
    console.error(error);
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

const get = function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    params.showLoading && showFullScreenLoading(); //显示等待框

    Axios.get(url, {
      params: params
    })
      .then(response => {
        params.showLoading && tryHideFullScreenLoading(); //隐藏等待框

        resolve(response);
      })
      .catch(err => {
        params.showLoading && tryHideFullScreenLoading(); //隐藏等待框

        reject(err);
      });
  });
};

/**
 * 封装post请求
 * @param url
 * @param params
 * @returns {Promise}
 */

const post = function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    params.showLoading && showFullScreenLoading(); //显示等待框

    Axios.post(url, params).then(
      response => {
        params.showLoading && tryHideFullScreenLoading(); //隐藏等待框

        resolve(response);
      },
      err => {
        params.showLoading && tryHideFullScreenLoading(); //隐藏等待框
        reject(err);
      }
    );
  });
};

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

const patch = function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.patch(url, data).then(
      response => {
        resolve(response);
      },
      err => {
        reject(err);
      }
    );
  });
};

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

const put = function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.put(url, data).then(
      response => {
        resolve(response);
      },
      err => {
        reject(err);
      }
    );
  });
};

const axois = function(url, config) {
  if (!config.params) {
    config.params = {};
  }
  if (!config.data) {
    config.data = {};
  }
  return new Promise((resolve, reject) => {
    Axios({
      url: url,
      ...config
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err);
      });
  });
};

export default {
  post,
  get,
  patch,
  put,
  axois
};



// WEBPACK FOOTER //
// ./src/request/http.js